<template>
  <div class="task-detail">
    <div class="header">
      <div class="return-btn" @click="handleCancel">
          <span>&lt;</span> <span>{{ $t('admin.rpa.btn.return') }}</span>
      </div>
    </div>
    <div class="info-container">
      <div class="base-info">
        <div class="account-info">
          <div class="info-container account">
            <div class="container-title">
              <div class="title">
                <span>{{ $t(`${i18nPrefix}.label.accountInfo`) }}</span>
              </div>
              <span class="title-suffix">{{ taskInfo.channel.i18nName || '' }}</span>
            </div>
            <div class="company-name">{{ taskInfo.company.i18nName || '' }}</div>
          </div>
          <div class="info-container bind">
            <label class="label">{{ $t(`${i18nPrefix}.label.bind`) }}</label>
            <div class="qr-code-image">
              <img :src="weChatQrUrl"/>
            </div>
          </div>
        </div>
        <div class="task-info">
          <div v-loading="monitor.loading" class="monitor-wrapper"  @click="handleMonitorClick">
            <div v-show="showControlBtn" class="monitor-btn-container" :class="monitor.src && monitor.image ? 'mask':''">
              <div class="control-btn" @click.stop="handleControlBtnClick">{{ $t(`${i18nPrefix}.btn.needOperate`) }}</div>
            </div>
            <div v-show="showBotActionLoading" class="monitor-show-loading">
              <div class="loading-text">
                <span>{{ $t(`${i18nPrefix}.label.restarting`) }}</span>
                <span class="dot">...</span>
              </div>
            </div>
            <div class="monitor">
              <img v-if="monitor.src && monitor.image" :src="monitor.image"/>
            </div>
          </div>
          <div class="operation">
            <div class="status-info">{{ taskLauncherStatusLabel }}</div>
            <el-popconfirm
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              icon="el-icon-info"
              icon-color="red"
              :disabled="true"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              @confirm="handleEnableChange"
            >
              <el-switch
                slot="reference"
                :value="taskIsEnable"
                class="status-switch"
                :disabled="true"
                :inactive-text="taskStatusLabel"
              >
              </el-switch>
            </el-popconfirm>
            <el-popconfirm
              :confirm-button-text='$t(`${i18nPrefix}.message.operatorConfirm`)'
              :cancel-button-text='$t(`${i18nPrefix}.message.operatorCancel`)'
              icon="el-icon-info"
              icon-color="red"
              :disabled="true"
              :title="$t(`${i18nPrefix}.message.operatorConfirmMessage`)"
              @confirm="handleRestartBtn"
            >
              <div class="restart-btn disable" slot="reference">
                <label class="label">{{ $t(`${i18nPrefix}.btn.restart`) }}</label>
                <i class="btn-icon el-icon-refresh-right"></i>
              </div>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <div class="counter-info">
        <CounterList
          class="job"
          v-loading="countData[featureTypeJobPosting].loading"
          :titleI18nKey="`${i18nPrefix}.label.job`"
          :data="jobCountData"
        >
          <template #titleBtn>
            <Dropdown
             v-model="countData[featureTypeJobPosting].day"
            :data="dayRangeList"
            @change="handelDayChange(featureTypeJobPosting)"/>
          </template>
        </CounterList>
        <CounterList
          class="resume"
          v-loading="countData[featureTypeDownload].loading"
          :titleI18nKey="`${i18nPrefix}.label.resume`"
          :data="resumeCountData"
        >
         <template #titleBtn>
            <Dropdown
              v-model="countData[featureTypeDownload].day"
              :data="dayRangeList"
              @change="handelDayChange(featureTypeDownload)"/>
          </template>
        </CounterList>
      </div>
    </div>
    <div class="email-resume-list-container" v-if="hasSuperAdminPermission && featureType === featureTypeDownload">
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="$t('admin.rpa.label.resumeDownloadListTitle')" name="1">
          <NoBorderTable
            class="resume-table"
            :noOperation="true"
            :noHeader="true"
            :tableColumns="tableColumns"
            :listData="resumeDownloadList"
            :rowClassName="tableRowClassName"
          >
            <template #resumeName="{ data }">
              <div class="resume-name-container">
                {{ data }}
              </div>
            </template>
            <template #status="{ row }">
              <template v-if="statusMapping[row.status]">
                <div class="status-container" :class="statusMapping[row.status].class">
                  <van-icon class="status-icon" :name="statusMapping[row.status].iconName"></van-icon>
                  <span class="status-name">{{ statusMapping[row.status].label }}</span>
                </div>
              </template>
            </template>
          </NoBorderTable>
          <el-pagination
            class="pagination"
            background
            layout="total, sizes, prev, pager, next"
            :total="pageInfo.total"
            :page-count="pageInfo.page"
            :page-size="pageInfo.pageSize"
            @current-change='handelPageChange'
            @size-change='handelSizeChange'
            >
          </el-pagination>
        </el-collapse-item>
      </el-collapse>
      <RectLoading v-show="showListLoading"/>
    </div>
    <el-dialog
      width="80%"
      :visible.sync="dialog.show"
      :before-close="cleanIframe"
    >
      <div v-loading="dialog.loading" class="iframe-container">
        <iframe ref="iframe" @load="handelIframeLoad" class="control-container" :src="controlIframeSrc"></iframe>
      </div>
    </el-dialog>
    <el-dialog
      width="80%"
      :visible.sync="monitor.dialog.show"
    >
      <div v-loading="monitor.dialog.loading" class="image-container">
        <img v-if="monitor.dialog.show" :src="monitor.image"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Dropdown from '@/components/formEditor/dropdown.vue'
import NoBorderTable from '@/components/tableList/noBorderTable.vue'
import CounterList from './components/counterList.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import { mapActions } from 'vuex'
import { addI18nProperty, createI18nProperty } from '@/i18n'
import moment from 'moment'
import {
  FEATURE_TYPE,
  CHANNEL_ID,
  ACTION_TYPE,
  LAUNCHER_STATUS_INFO_MAP,
  LAUNCHER_HAS_SCREENSHOT_STATUS,
  LAUNCHER_DISPLAY_STATUS,
  dayRange
} from '@/constant/rpa'

export default {
  components: {
    Dropdown,
    CounterList,
    NoBorderTable,
    RectLoading
  },
  data () {
    const featureTypeDownload = FEATURE_TYPE.SHI_XI_SENG_SAVE_RESUME
    const featureTypeJobPosting = FEATURE_TYPE.JOB_POSTING
    return {
      i18nPrefix: 'admin.rpa',
      featureTypeDownload,
      featureTypeJobPosting,
      taskIsEnable: false,
      showListLoading: false,
      showBotActionLoading: false,
      autoGetBotActionStatus: false,
      activeNames: ['1'],
      screenShotImgUrl: '',
      weChatQrUrl: '',
      controlUrl: null,
      controlIframeSrc: null,
      taskSetting: {
        autoRefresh: true,
        refreshTime: 60000
      },
      botStatus: '',
      statusMapping: {
        success: {
          label: 'Success',
          class: 'success',
          iconName: 'passed'
        },
        processing: {
          label: 'Processing',
          class: 'processing',
          iconName: 'more-o'
        },
        fail: {
          label: 'Fail',
          class: 'fail',
          iconName: 'close'
        },
        pending: {
          label: 'Pending',
          class: 'Pending',
          iconName: 'clock-o'
        }
      },
      pageInfo: {
        page: 1,
        total: 0,
        pageSize: 10
      },
      resumeDownloadList: [],
      taskInfo: {
        id: null,
        channel: {
          i18nName: null
        },
        company: {
          i18nName: null
        },
        account: {},
        feature_type: null,
        is_enabled: false,
        can_operate: false
      },
      countData: {
        [featureTypeDownload]: {
          data: {
            total: 0,
            processing: 0
          },
          day: 0,
          loading: false
        },
        [featureTypeJobPosting]: {
          data: {
            posted: 0,
            post_in_queue: 0,
            closed: 0,
            close_in_queue: 0
          },
          day: 0,
          loading: false
        }
      },
      screenShotUrl: null,
      screenTimer: null,
      dialog: {
        show: false,
        loading: false
      },
      monitor: {
        loading: false,
        autoRefresh: true,
        frame: 2,
        src: null,
        image: null,
        dialog: {
          show: false,
          loading: false
        }
      }
    }
  },
  computed: {
    hasSuperAdminPermission () {
      return this.$parent.hasSuperAdminPermission
    },
    showControlBtn () {
      return LAUNCHER_STATUS_INFO_MAP.WAIT_VERIFY.statusList.includes(this.botStatus)
    },
    taskStatusLabel () {
      return this.$t(`${this.i18nPrefix}.btn.status.${this.taskIsEnable ? 'enable' : 'disable'}`)
    },
    taskLauncherStatusLabel () {
      const statusKey = _.findKey(LAUNCHER_STATUS_INFO_MAP, ({ statusList }) => statusList.includes(this.botStatus))
      return this.$t(`${this.i18nPrefix}.launcherDisplayStatus.${statusKey || LAUNCHER_DISPLAY_STATUS.UNKNOWN}`)
    },
    dayRangeList () {
      return _.map(dayRange, item => {
        return { labelI18nKey: `${this.i18nPrefix}.dayRange.${item}`, value: item }
      })
    },
    jobCountData () {
      const countData = this.countData[this.featureTypeJobPosting].data
      const posted = countData?.posted || 0
      const postInQueue = countData?.post_in_queue || 0
      const closed = countData?.closed || 0
      const closeInQueue = countData?.close_in_queue || 0
      const data = [
        { labelI18nKey: `${this.i18nPrefix}.label.postedJob.new`, value: posted },
        { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.new`, value: postInQueue },
        { labelI18nKey: `${this.i18nPrefix}.label.postedJob.close`, value: closed },
        { labelI18nKey: `${this.i18nPrefix}.label.inQueueJob.close`, value: closeInQueue }
      ]
      return data
    },
    resumeCountData () {
      const count = this.countData[this.featureTypeDownload].data
      const total = count.total || 0
      const handled = count?.succeed || 0
      const data = [
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.downloaded`, value: total },
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.handled`, value: handled },
        { labelI18nKey: `${this.i18nPrefix}.label.downloadResume.gap`, value: total - handled }
      ]
      return data
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t('admin.rpa.label.table.header.emailSubject'),
          dataKey: 'email_subject',
          slotName: 'resumeName',
          width: '105'
        },
        {
          label: this.$t('admin.rpa.label.table.header.candidateName'),
          dataKey: 'candidate.name',
          width: '100'
        },
        {
          label: this.$t('admin.rpa.label.table.header.reqId'),
          dataKey: 'job.id'
        },
        {
          label: this.$t('admin.rpa.label.table.header.downloadTime'),
          dataKey: 'created_time',
          formatter: this.formatDate,
          width: '100'
        },
        {
          label: this.$t('admin.rpa.label.table.header.uploadToAjingaTime'),
          dataKey: 'import_end_time',
          formatter: this.formatDate,
          width: '130'
        },
        {
          label: this.$t('admin.rpa.label.table.header.status'),
          dataKey: 'status',
          slotName: 'status'
        }
      ]
      return columns
    },
    taskId () {
      return this.$route.params.taskId
    },
    featureType () {
      return this.taskInfo.feature_type
    }
  },
  async created () {
    await this.initData()
  },
  async mounted () {
    if (this.$route.query.needVerify === '1') {
      await this.handleControlBtnClick()
    }
  },
  destroyed () {
    if (this.monitor.autoRefresh) {
      this.monitor.autoRefresh = false
    }
    if (this.taskSetting.autoRefresh) {
      this.taskSetting.autoRefresh = false
    }
    this.showBotActionLoading = false
    this.autoGetBotActionStatus = false
  },
  methods: {
    ...mapActions('rpa', ['getQrUrl', 'getTaskList', 'getTaskScreenshot', 'getTaskControl', 'getMonitorImage', 'updateTaskAction', 'updateTask',
      'getEmailResumeReportData', 'getEmailResumeList', 'getTaskAction']),
    async initData () {
      await this.initTaskInfo()
      this.initControl()
      this.initMonitor()
      this.initQrCode()
      this.initCountData()
      if (this.hasSuperAdminPermission) {
        this.initResumeDownloadData()
      }
      setTimeout(this.refreshTaskInfo, this.taskSetting.refreshTime)
    },
    async initResumeDownloadData () {
      this.handelPageChange(1)
    },
    async initTaskInfo () {
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getTaskList(params)
      if (resp) {
        const taskInfo = resp.task
        const channelInfo = taskInfo.channel
        const channelIdKey = _.findKey(CHANNEL_ID, val => val === channelInfo.id)
        createI18nProperty(channelInfo, 'i18nName', `${this.i18nPrefix}.channelName.${channelIdKey}`)
        addI18nProperty(taskInfo.company, 'i18nName', 'cn_name', 'name')
        this.taskInfo = taskInfo
        this.botStatus = resp.status
        this.taskIsEnable = this.taskInfo.is_enabled
      }
    },
    async initCountData () {
      const featureType = FEATURE_TYPE.SHI_XI_SENG_SAVE_RESUME
      this.countData[featureType].loading = true
      try {
        const params = {
          channel_id: this.channelId,
          days_delta: this.countData[featureType].day,
          task_id: this.taskId
        }
        const resp = await this.getEmailResumeReportData(params)
        if (resp) {
          this.countData[featureType].data = resp
        }
      } finally {
        this.countData[featureType].loading = false
      }
    },
    async initMonitor () {
      if (!this.hasSuperAdminPermission || !LAUNCHER_HAS_SCREENSHOT_STATUS.includes(this.botStatus)) {
        return
      }
      const monitor = this.monitor
      monitor.loading = true
      const resp = await this.getTaskScreenshot({
        task_id: this.taskId
      })
      if (resp) {
        monitor.src = resp.screenshot
      }
      monitor.autoRefresh = true
      this.refreshMonitor()
      monitor.loading = false
    },
    async refreshMonitor () {
      const monitor = this.monitor
      if (!monitor.src) {
        monitor.autoRefresh = false
        return
      }
      let resp = null
      try {
        resp = await this.getMonitorImage(monitor.src)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
      if (resp && resp.value && !resp.value.error) {
        monitor.image = `data:image/png;base64,${resp.value}`
        if (monitor.autoRefresh) {
          setTimeout(this.refreshMonitor, 1000 / monitor.frame)
        }
      } else {
        monitor.image = null
        monitor.autoRefresh = false
      }
    },
    async initControl () {
      if (!this.showControlBtn) {
        return
      }
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getTaskControl(params)
      if (resp && resp.control_path) {
        this.controlUrl = resp.control_path
        this.controlIframeSrc = this.controlUrl
      }
    },
    async refreshTaskInfo () {
      if (!this.taskSetting?.autoRefresh) {
        return
      }
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getTaskList(params)
      if (resp) {
        const oldStatus = this.botStatus
        const taskInfo = resp.task
        const channelInfo = taskInfo.channel
        const channelIdKey = _.findKey(CHANNEL_ID, val => val === channelInfo.id)
        createI18nProperty(channelInfo, 'i18nName', `${this.i18nPrefix}.channelName.${channelIdKey}`)
        addI18nProperty(taskInfo.company, 'i18nName', 'cn_name', 'name')
        this.taskInfo = taskInfo
        this.botStatus = resp.status
        this.taskIsEnable = this.taskInfo.is_enabled

        if (!this.monitor.src || this.botStatus !== oldStatus) {
          this.initMonitor()
          this.initControl()
        }
        if (this.taskSetting && this.taskSetting.autoRefresh) {
          setTimeout(this.refreshTaskInfo, this.taskSetting.refreshTime)
        }
      }
    },
    async initQrCode () {
      const params = {
        task_id: this.taskId
      }
      const resp = await this.getQrUrl(params)
      if (resp) {
        this.weChatQrUrl = resp
      }
    },
    async handleEnableChange () {
      if (!this.taskInfo.can_operate) {
        return
      }
      const params = {
        id: this.taskInfo.id,
        is_enabled: !this.taskInfo.is_enabled
      }
      await this.updateTask(params)
      this.taskIsEnable = !this.taskIsEnable
    },
    async handleRestartBtn () {
      if (!this.taskInfo.can_operate) {
        return
      }
      const params = {
        task_id: this.taskId,
        action: ACTION_TYPE.RESTART
      }
      const resp = await this.updateTaskAction(params)
      if (resp?.action_uid) {
        this.showBotActionLoading = true
        this.autoGetBotActionStatus = true
        this.monitor.autoRefresh = false
        this.monitor.src = ''
        this.controlUrl = ''
        this.getBotActionStatus(resp.action_uid)
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    formatDate (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm') : ''
    },
    handleEditTask () {
      if (this.taskId) {
        this.$router.push({ name: 'rpaEditTask', params: this.taskId })
      }
    },
    async handleControlBtnClick () {
      this.dialog.show = true
      this.dialog.loading = true
      if (!this.controlUrl) {
        await this.initControl()
      } else {
        this.controlIframeSrc = this.controlUrl
      }
    },
    handleMonitorClick () {
      if (this.monitor.src && this.monitor.image) {
        this.monitor.dialog.show = true
      }
    },
    resetControlIframeCss (resolve) {
      const contentDocument = this.$refs.iframe.contentDocument
      if (!contentDocument) {
        return
      }
      const el = contentDocument.querySelector('.screencast')
      if (!el) {
        setTimeout(() => this.resetControlIframeCss(resolve), 500)
        return
      }
      el.firstElementChild.style.display = 'none'
      el.parentElement.lastElementChild.style.display = 'none'
      el.parentElement.shadowRoot.querySelector('div .shadow-split-widget-sidebar').remove()
      el.parentElement.shadowRoot.querySelector('div .shadow-split-widget-resizer').remove()
      el.querySelector('.screencast-viewport').style.margin = 'auto'
      contentDocument.dispatchEvent(new Event('resize'))
      resolve()
    },
    async handelIframeLoad () {
      try {
        if (!this.controlIframeSrc) {
          return
        }
        await new Promise(this.resetControlIframeCss)
      } finally {
        this.dialog.loading = false
      }
    },
    cleanIframe () {
      this.controlIframeSrc = ''
      this.dialog.show = false
    },
    async handelPageChange (val) {
      this.showListLoading = true
      try {
        this.pageInfo.page = val
        const resp = await this.getEmailResumeList({
          task_id: this.taskInfo.id,
          page_num: this.pageInfo.page,
          page_size: this.pageInfo.pageSize
        })
        if (resp) {
          this.pageInfo.total = resp.total_count
          this.resumeDownloadList = resp.list
        }
      } finally {
        this.showListLoading = false
      }
    },
    handelSizeChange (val) {
      this.pageInfo.pageSize = val
      this.handelPageChange(this.pageInfo.page)
    },
    handelDayChange (type) {
      if (!type) {
        return
      }
      this.initCountData(type)
    },
    handleCancel () {
      this.$router.push('/v-admin/rpa/index')
    },
    async getBotActionStatus (actionUid) {
      if (!actionUid) {
        this.autoGetBotActionStatus = false
        return
      }
      const params = {
        task_id: this.taskId,
        action_uid: actionUid
      }
      const resp = await this.getTaskAction(params)
      if (resp === 'PENDING' && this.autoGetBotActionStatus) {
        setTimeout(this.getBotActionStatus, 1000, actionUid)
      } else {
        this.showBotActionLoading = false
        this.initMonitor()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.task-detail {
  .header {
    background: #FFFFFF;
    padding: 20px 20px 0 20px;

    .return-btn {
      cursor: pointer;
      font-size: 16px;

      > span {
        &:last-child {
          margin-left: 5px;
        }
      }
    }
  }

  .info-container {
    padding: 20px;
    border-radius: 5px;
    background: #fff;

    .base-info {
      display: flex;
      margin-bottom: 40px;
      justify-content: space-between;

      .account-info {
        width: 38%;

        .info-container {
          border-radius: 5px;
          background: #f7f7f7;

          & + .info-container {
            margin-top: 20px;
          }

          .container-title {
            display: flex;
            align-items: flex-end;

            .title {
              flex: 1;
              margin-bottom: 5px;
              padding-bottom: 5px;
              border-bottom: 1px solid #666666;
              font-size: 18px;
              font-weight: bold;
              color: #232323;
              position: relative;

              &::before {
                content: '';
                display: block;
                width: 30px;
                border-bottom: 4px solid #666666;
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }

            .title-suffix {
              margin-left: 10px;
              line-height: 1;
              font-size: 20px;
              color: #606060;
            }
          }

          &.account {
            position: relative;

            .company-name {
              margin-top: 15px;
              font-size: 20px;
              color: #606060;
            }

            .account-info-line {
              font-size: 16px;
              color: #606060;
            }

            .edit-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 18px;
              cursor: pointer;
            }
          }

          &.bind {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .label {
              font-size: 20px;
              color: #606060;
            }

            .qr-code-image {
              width: 150px;
              height: 150px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }

      .task-info {
        display: flex;
        width: 58%;
        height: 500px;
        border: 1px solid #dcdfe6;
        border-top: 0;
        flex-direction: column;

        .monitor-wrapper {
          flex: 1px;
          position: relative;

          .monitor-btn-container {
            display: flex;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;

            &.mask {
              background-color: rgba($color: #000000, $alpha: 0.3);
              opacity: 1;
            }

            .control-btn {
              margin: auto;
              padding: 4px 8px;
              font-size: 16px;
              border: 1px solid #606060;
              color: #fff;
              cursor: pointer;
            }
          }

          .monitor-show-loading {
            position: absolute;
            display: flex;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            font-size: 18px;

            .loading-text {
              margin: auto;
              cursor: default;

              .dot {
                font-family: simsun;
                display: inline-block;
                width: 1.5em;
                animation: dot 3s infinite step-start;
                overflow: hidden;
                vertical-align: bottom;
              }

              @keyframes dot {
                0% {width: 0; margin-right: 1.5em;}
                33% {width: 0.5em; margin-right: 1em;}
                66% {width: 1.0em; margin-right: 0.5em;}
                100% {width: 1.5em; margin-right: 0;}
              }

            }
          }

          .monitor {
            height: 100%;
            background: rgba($color: #000000, $alpha: 0.4);

            > img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .operation {
          display: flex;
          padding: 10px;
          border-top: 1px solid #dcdfe6;
          justify-content: flex-end;
          align-items: center;

          .status-info {
            margin-left: 0;
            margin-right: auto;
            font-size: 14px;
          }

          .status-switch {
            margin-right: 30px;

            ::v-deep {
              .el-switch__label.is-active {
                color: inherit;
              }
            }
          }

          .restart-btn {
            margin-right: 0px;
            cursor: pointer;

            &:hover:not(.disable) {
              .btn-icon {
                transform: rotateZ(360deg);
              }
            }

            .label {
              font-size: 14px;
              cursor: pointer;
              vertical-align: middle;
            }

            &.disable {
              opacity: .6;
              cursor: not-allowed;

              .label {
                cursor: not-allowed;
              }
            }

            .btn-icon {
              margin-left: 5px;
              vertical-align: middle;
              font-size: 24px;
              color: #39a7c9;
              transition: transform .3s;
              transform: rotateZ(0);
            }
          }
        }
      }
    }

    .counter-info {
      display: flex;
      justify-content: space-between;

      .counter-list-container {
        width: 48%;
      }
    }
  }

  .email-resume-list-container {
    margin-top: 20px;
    position: relative;
    background-color: #FFFFFF;

    .download-button-container {
      right: 40px;
      position: absolute;
      background-color: #39a7c9;
      color: #FFFFFF;
      top: 8px;
      padding: 8px 15px;
      cursor: pointer;
    }

    .resume-name-container {
      text-align: left;
      margin-left: 30px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .status-container {
      display: flex;
      margin-left: 15px;
      align-items: center;
      justify-content: flex-start;

      .status-icon::before {
        // color: #FFFFFF;
        border-radius: 50%;
        font-size: 17px;
        border: 0;
      }

      .status-name {
        margin-left: 10px;
      }

      &.success {
        color: #3f863e;

        // .status-icon::before {
        //   background-color: #3f863e;
        // }
      }

      &.fail {
        color: #881818;

        // .status-icon::before {
        //   background-color: #881818;
        // }
      }

      &.processing {
        color: #186e88;

        // .status-icon::before {
        //   background-color: #186e88;
        // }
      }

    }

    .pagination {
      text-align: right;
      margin-right: 10px;
      padding: 10px;
    }

    ::v-deep .el-collapse {
      border: 0px;

      .el-collapse-item {
        margin-top: 15px;
      }

      .el-collapse-item__header {
        padding: 0 20px;
        font-size: 16px;
        border: 0px;
        color: #000000;
        font-weight: 600;

        > i {
          margin-left: 15px;
          transform: rotate(-90deg);

          &.is-active {
            transform: rotate(90deg);
          }
        }
      }

      .el-collapse-item__wrap {
        margin-top: 10px;
        border: 0px;
      }

      .el-collapse-item__content {
        padding: 0 25px 20px 25px;
      }

      .el-table__header {
        .el-table__cell {
          font-size: 14px;
          padding: 20px 0;
          color: #000000;
          font-weight: 600;

          &.is-leaf {

            &:first-child {
              text-align: left;
              padding-left: 25px;
            }

            background-color: #FFFFFF;
          }
        }
      }

      .el-table__body {
          .el-table__cell {
            padding: 20px 0;

            .cell {
              padding: 0 5px;
            }
          }

          .gray-background {
            background: #f7f7f7;
          }
      }
    }

    ::v-deep .loading-mask {
      position: absolute;
    }
  }

  .iframe-container {
    overflow: hidden;

    .control-container {
      width: 100%;
      height: 46vw;
      border: 0;
    }
  }

  .image-container {
    text-align: center;

    > img {
      width: 90%;
    }
  }
}
</style>
